import IdGenerator from 'scripts/domain/contracts/id_generator';
import Err from 'models/err';
import mixin from '../../lib/mixin';
import Observable from '../../lib/observable_mixin';
import qconsole from 'scripts/lib/qconsole';

const DEFAULT_TIMEOUT = 30000; // 30s

export default class ExternalCustomerLookupHttpGateway {
  constructor(http, requestorId) {
    this.http = http;
    this.requestorId = requestorId;
  }

  init({ orgId } = {}) {
    this.orgId = orgId;
  }

  get version() {
    return '1';
  }

  get entityName() {
    return 'external-customer-lookup';
  }

  get url() {
    return `/api/v${this.version}/orgs/${this.orgId}/${this.entityName}`;
  }

  request(payload) {
    const correlationId = IdGenerator.newId();
    this.http.post(this.url, payload, this.handleResponse.bind(this, correlationId), {
      timeout: DEFAULT_TIMEOUT,
      headers: { 'Gladly-Correlation-Id': correlationId, 'Gladly-Requestor-Id': this.requestorId },
    });

    return { correlationId };
  }

  handleResponse(correlationId, err, res) {
    if (err != null) {
      qconsole.error('error during external customer lookup: ', err);

      this.notifyObservers('handleFetchError', {
        errorsDto: { errors: [{ code: 'unexpected_error' }] },
        correlationId,
      });
    } else if (res.status !== 200) {
      this.notifyObservers('handleFetchError', {
        errorsDto: errors(res.response),
        correlationId,
      });
    } else {
      this.notifyObservers('handleFetchSuccess', {
        fetchResultDto: res.response,
        correlationId,
      });
    }
  }
}
function errors(response) {
  if (response && response.errors) {
    return response;
  } else {
    qconsole.error('error response from external customer lookup: ', response);
    return { errors: [{ detail: 'error during customer lookup', code: Err.Code.UNEXPECTED_ERROR }] };
  }
}

mixin(ExternalCustomerLookupHttpGateway.prototype, Observable);



// WEBPACK FOOTER //
// ./src/scripts/adapters/gateways/external_customer_lookup_http_gateway.js